import React from 'react'
import SeminarApplyingList from 'components/seminar/SeminarApplyingList'

const SeminarApplying = ({ data, buildTime }) => {
  return (
    <div className="seminarApplying">
      <h2 className="seminarApplying__heading2">申込受付中のセミナー</h2>
      <SeminarApplyingList data={data} buildTime={buildTime} />
    </div>
  )
}

export default SeminarApplying
